import { NgModule } from '@angular/core';

import { DirettaPortaleRouting } from './diretta-portale.routing';
import { DirettaPortaleComponent } from './diretta-portale.component';
import { FormazioniModule } from '../formazioni/formazioni.module';
import { SharedModule } from '../shared/shared.module';
import { CronacaModule } from '../cronaca/cronaca.module';

@NgModule({
    imports: [DirettaPortaleRouting, SharedModule, FormazioniModule, CronacaModule],
    declarations: [DirettaPortaleComponent],
    exports: [DirettaPortaleComponent],
    providers: []
})
export class DirettaPortaleModule { }


// WEBPACK FOOTER //
// ./src/app/diretta-portale/diretta-portale.module.ts